<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h3>History log</h3>
            <div class="d-flex">
                <div @click="sortByName" class="sort_by by_name">
                    <svg v-if="by_name === 'asc'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z" fill="#D0D0D0"/>
                    </svg>
                    <svg v-if="by_name === 'desc'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 6H9V8H3V6ZM3 18V16H21V18H3ZM3 11H15V13H3V11Z" fill="#D0D0D0"/>
                    </svg>
                    <span>By Name</span>
                </div>
                <div @click="sortByDate" class="sort_by by_date">
                    <svg v-if="by_date === 'asc'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z" fill="#D0D0D0"/>
                    </svg>
                    <svg v-if="by_date === 'desc'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 6H9V8H3V6ZM3 18V16H21V18H3ZM3 11H15V13H3V11Z" fill="#D0D0D0"/>
                    </svg>
                    <span>By date</span>
                </div>

            </div>
        </div>
        <div class="black_block text-grey">
            <div class="block_top_panel block_top_panel_updown d-flex justify-content-between align-items-center mb-4">
                <h5 class="block_top_panel__title">Filters</h5>
                <div>
                    <button @click.prevent="clearAll" class="btn btn-border btn-sm">CLEAR ALL</button>
                </div>
            </div>
            <div class="input_search input_search_border mb-4">
                <input v-model="model_find" @keypress.enter="findname" type="text" placeholder="Search" class="form-control">                
                <!-- <input v-model="model_history.search" type="text" placeholder="Search" class="form-control text-grey"> -->
                <svg @click="findname" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
                </svg>
            </div>

            <div v-show="categories.length > 0" class="category_select d-flex align-items-center justify-content-between mb-3">
                <label for="select_count_item" class="category_select_label">Category:</label>
                <div class="position-relative w-100">
                    <select v-model="model_category" @change="checkCategory"  id="select_count_item" class="form-select form-select-category form-select-border-bottom" aria-label="Default select example">
                        <option value="all">Select categories</option>
                        <option v-for="category in categoriesItem" :value="`${category.id}:${category.name}`">{{ category.name }}</option>
                    </select>
                </div>
            </div>

            <div v-show="change_category.length > 0" class="selected_category">
                <div v-for="cc in change_category" class="selected_category_item">{{cc.name}} <div @click="removeCheckCategory(cc)" class="btn-close"></div></div>
            </div>

            <h5 class="block_top_panel__title mt-5">Global time</h5>

            <div class="d-flex align-items-center mb-3">
                <div class="black_block__title">Begin</div>
                <input @change="filterByDate" v-model="model_history.begin" type="datetime-local" class="form-control">
                <div @click="model_history.begin = ''" class="btn-close"></div>
            </div>
            <div class="d-flex align-items-center mb-3">
                <div class="black_block__title">End</div>
                <input @change="filterByDate"  v-model="model_history.end" type="datetime-local" class="form-control">
                <div  @click="model_history.end = ''"  class="btn-close"></div>
            </div>


        </div>
        
        
        <div class="histories-cards_wrap">
            <div 
                v-for="(history) in historiesItem" :key="history.id" 
                class="hystorylog_person d-flex justify-content-between align-items-center black_block p-0 mt-3"            
            >            
                <div 
                    class="d-flex align-items-center"
                    style="cursor: pointer"
                    @click="goToPerson(history)"
                >                    
                    <div 
                        class="hystorylog_person__img" 
                        v-bind:style="{ 
                                'background-image': `url(
                                    ${history.imageurl}
                                )` 
                            }"
                    >
                    </div>                                    
                    <div class="hystorylog_person__title d-flex table-list-row__action">
                        <h6>{{ history.person.first_name}} {{history.person.last_name }}</h6>
                        <div class="date">{{history.recognized_at}}</div>
                        <div
                            v-if="history.source_label || history.video_name"
                            class="source"
                            :title="history.source_label || history.video_name"
                        >{{ history.source_label || history.video_name }}</div>
                    </div>
                </div>
                <div class="hystorylog_person__map map_icon">
                    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z" fill="white" fill-opacity="0.8"/>
                    </svg>
                </div>
            </div>
        </div>
        <!-- <hrdate
            date="01.03.2021"
        ></hrdate> -->
    </div>
</template>

<script>
import {bus} from '../../bus';
import hrdate from "../hrdate";
import axios from "axios";
export default {    
    props: [      
        'video_type_id',
        'person_id',
        'category_id'
    ],
    data(){
        return{
            data: [],
            histories: [],
            categories: [],
            categoriesIds: [],
            arh_categories: [],
            model_category: 'all',
            model_history: {
                search: '',
                begin: '',
                end: ''
            },
            model_find: '',
            change_category: [],
            sort: 'recognized_at',
            sorttype: 'desc',
            by_name: 'asc',
            by_date: 'asc',
            model_countitempage: 10,
            step: 10,
            page: 1,
            waitingForAnResponse: false,
            isLoad: false,
            intervalid1:''
            // currentPage: 1,
        }
    },
    methods: {
        filterByDate(){
            // this.model_history.begin = this.model_history.begin.replace('T', " ");
            // this.model_history.end = this.model_history.end.replace('T', " ");
            console.log('model_history.begin ', this.model_history.begin );            
            console.log('model_history.begin ', this.model_history.begin );
            this.getHistories();
        },        
        scroll() {               
            let listHistories = document.querySelector('.histories-cards_wrap')
            
            listHistories.onscroll = () => {
                /*
                    clientHeight высота содержимого вместе с полями padding, но без полосы прокрутки.
                    offsetHeight «внешняя» высота блока, включая рамки.
                    scrollHeight полная внутренняя высота, включая прокрученную область.
                */
                
                let bottomOfListHistories =
                listHistories.scrollTop + listHistories.clientHeight + 10 >=
                listHistories.scrollHeight;

                /* listHistories.scrollHeight > 40 because otherwise it reacts to decreasing height when clearing the list
                    40 random approximate number */
                if (
                    bottomOfListHistories && listHistories.scrollHeight > 40
                    && 
                    !this.waitingForAnResponse
                ) {
                    
                    this.loadingDataFromServer()
                }
            };
        },        
        loadingDataFromServer() {                
            this.waitingForAnResponse = true    // flag for not reppeat before respons from server
            this.isLoad = true  // enable "Loading..." down list
            
            this.model_countitempage += this.step;
            console.log('this.step', this.step);
            console.log('this.model_countitempage', this.model_countitempage);                
            let response = this.getHistories();

            this.isLoad = false
        },                
        getCategories(){
            axios.get( '/getcategories').then((responce)=>{

                this.categories = responce.data;

                if(this.arh_categories.length <= 0){
                    this.arh_categories = this.categories;
                }

                console.log('history categories', responce);

            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        updateHistories(){
            this.getHistories();
            // console.log('Update histories! )');
            setTimeout(()=>{
                    this.updateHistories();
            }, 30000);
        },        
        async getHistories(upload = false){
            const url = `/histories/`;
            // Page-level category_id (category route) + sidebar chips.
            const catIds = [...this.categoriesIds];
            if (this.category_id && !catIds.includes(Number(this.category_id))) {
                catIds.push(Number(this.category_id));
            }
            const params = {
                video_type_id: this.video_type_id,
                page: this.page,
                countitempage: this.model_countitempage,
                sort: this.sort,
                sorttype: this.sorttype,
                name: this.model_find,
                begin: this.model_history.begin,
                end: this.model_history.end,
                categories: catIds,
            }
            if(this.person_id){
                params.person_id = this.person_id;                
            };
            if (this.category_id) {
                params.category_id = Number(this.category_id);
            }
            
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'ContentType': 'application/json'
                    }
                }
            ).then((responce)=>{                
                this.data = responce.data;                
                this.histories = responce.data.data;


                // console.log('this.histories: ', this.histories);
                
                // console.log('Histories updated 1!');
                
                this.waitingForAnResponse = false;

                if(upload){
                    bus.$emit('historiesloaded', {
                        'lasthistory': this.histories[0]
                    });

                    console.log('this.histories from first upload: ', this.histories);        

                }
                
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        findname(){            
            this.getHistories();
        },
        mediaUrl(image){
            if (!image) return '';
            if (image.fullpath) return image.fullpath;
            const p = image.path || '';
            if (!p) return '';
            if (p.startsWith('data:') || p.startsWith('http') || p.startsWith('/')) return p;
            if (p.startsWith('../')) return '/' + p.replace(/^\.\.\//, '');
            return `/images/${p}`;
        },
        // goToPerson(person_id, category_id, history ){
        goToPerson(history){            
            console.log('history: ', history);
                                    
            if(history.lastreportid){
                location.href=`/reports/${history.lastreportid}#person_${history.person_id}`;
            } else {
                // console.error(error);
                let category_id = history.person.categories[0].id,
                    person_id = history.person.id;
                location.href=`/categories/${category_id}/persons/${person_id}`;
            }
            
            // try {
            //     location.href=`/reports/${history.person.reports[0].report_id}#person_${history.person_id}`;
            // } catch (error) {
            //     // console.error(error);
            //     let category_id = history.person.categories[0].id,
            //         person_id = history.person.id;
            //     location.href=`/categories/${category_id}/persons/${person_id}`;
            // }
        },
        checkCategory(){
            let spl = this.model_category.split(':');
            let id_cat = Number(spl[0]);
            let  title_cat = spl[1];

            this.change_category.push({
                id: id_cat,
                name: title_cat
            });
            // console.log('this.change_category', this.change_category);

            let data = [];

            this.categories.map((item) => {
                if(id_cat && Number(item.id) !== id_cat){
                    data.push(item);
                }
            });

            this.model_category = 'all';
            this.categories = [];
            this.categories = data;
                        

            this.categoriesIds = this.change_category.map(category=>category.id)
            
            console.log( 'this.categoriesIds', this.categoriesIds );
            
            this.getHistories();

            
            // console.log( 'this.categoriesIds', this.categoriesIds );
        },
        sortByName(){  
            if(this.sorttype === 'asc'){
                this.sorttype = 'desc';
                this.by_name =  'desc';
            }else{
                this.sorttype = 'asc';
                this.by_name =  'asc';
            }
            this.sort = 'name'
            this.getHistories();
        },
        sortByDate(){
            if(this.by_date === 'asc'){
                this.sorttype = 'desc';
                this.by_date = 'desc';
            }else{
                this.sorttype = 'asc';
                this.by_date = 'asc';
            }
            this.sort = 'recognized_at'
            this.getHistories();
        },
        removeCheckCategory(category){
            this.categories.push(category);

            let new_change_category = []

            this.change_category.map((item) => {
                if(item.id !== category.id){
                    new_change_category.push(item);
                }
            });

            this.change_category = new_change_category;

            this.categoriesIds = this.change_category.map(category=>category.id)
            
            // console.log( 'this.categoriesIds', this.categoriesIds );
            
            this.getHistories();

        },
        clearAll(){
            this.by_name = 'desc';
            this.by_date = 'desc';
            this.model_history = {
                search: '',
                begin: '',
                end: ''
            }
            this.change_category = [];
            this.categoriesIds = [];
            this.categories = this.arh_categories;
            this.model_find = '';
            this.getHistories();
        },
        todo(){           
            this.intervalid1 = setInterval(() => {
                let history = this.histories[0] ? this.histories[0] : 'begin';
                // console.log('history from interval: ', history);
                bus.$emit('historiesloaded', {
                    'lasthistory': history
                }); 
            }, 10000);
        }
    },
    computed: {
        categoriesItem(){
            return this.categories;
        },
        historiesItem(){
            // Return new objects — never rely on mutating map callback `this`
            // (stale app.js once compiled map to a bare function and blanked the sidebar).
            const mediaUrl = this.mediaUrl.bind(this);
            return (this.histories || []).map((history) => {
                const imageurl = mediaUrl(
                    (history && history.image) || (history.person && history.person.image)
                );
                return Object.assign({}, history, { imageurl });
            });
        }
    },
    mounted(){
        this.getCategories();
        this.getHistories(true);

        


        this.updateHistories();
        this.scroll();
        this.todo();
        bus.$on('historiesupdated', () => {
            this.getHistories();
            console.log('Histories updated 2!');
        }) 
        console.log('this.person_id: ', this.person_id);
    },
    components: {
        hrdate
    }
}
</script>


<style lang="scss" scoped>

.histories-cards_wrap {
    overflow: auto;
    height: 320px;
}
.category_select{
    display: flex;
    align-items: center;
    label{
        margin-right: 1rem;
    }
}
#select_count_item{
    outline: 0px;
    border: none;
    border-bottom: 1px solid #828282;
    box-shadow: none;
    border-radius: 0;
    cursor: pointer;
    &:after{
        content: 'Up';
    }
    &:checked,
    &:focus{
        outline: 0px;
        border: none;
        border-bottom: 1px solid #828282;
        box-shadow: none;
    }
}
.selected_category{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 1rem;
    .selected_category_item{
        background: rgba(255, 255, 255, 0.2);
        padding: 0.2rem 0.2rem 0.2rem 1rem;
        border-radius: 20px;
        color: #fff;
        align-items: center;
        display: flex;
        font-size: .8rem;
        .btn-close{
            margin-left: .5rem;
            width: 15px;
            height: 15px;
            //background: none;
            position: relative;
            min-width: 15px;
            min-height: 15px;
            &:before{
                width: 11px;
                top: 10px;
            }
            &:after{
                width: 11px;
                top: 10px;
            }
        }
    }
}
.black_block__title{
    min-width: 70px;
    text-align: left;
    margin-right: 1rem;
}
</style>
